import { Links } from '@/shared/constants/navegacao';
import { DataIso } from '@/shared/utils/datas';

/** Painel de atividades pendentes e enviadas do mês atual. */
export function buildMovimentacoesPendentesEnviadasHref(
  referenceDate = new Date(),
): string {
  const mes = DataIso(referenceDate, 'yyyy-MM');
  const params = new URLSearchParams({
    referenciaI: mes,
    referenciaF: mes,
    defensoriaId: '0',
    nucleoId: '0',
    defensorId: '0',
  });
  return `${Links.Atividades_Pendentes}?${params.toString()}`;
}

/** Listagem de tipos de atividade. */
export function buildMovimentacoesTiposHref(): string {
  return Links.Movimentacoes_Tipos_Index;
}
